export function mountNext(next) {
    let nextHtml = next.html;
    let response = nextHtml.replace(
    /(<\/?)body( .+?)?>/gi,
    "$1notbody$2>",
    nextHtml
    );

    var div = document.createElement("div");
    div.innerHTML = response;
    return div;
}

export function replaceContent(next, selector) {
    const div = mountNext(next);

    let currentItem = document.body.querySelector(selector);
    if (currentItem) {
        var nextItem = div.querySelector(selector);
        if (nextItem) {
            currentItem.replaceWith(nextItem);
            currentItem = nextItem;
        }
    }
}
